// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadMore_loadingContainer__pMdm9","loadingSpinner":"LoadMore_loadingSpinner__-JiMg"};